module.exports = __webpack_public_path__ + "img/114.4.39cf4a18.png";